<template>
  <div class="ah-Header">
    <span class="ah-Name">{{ name }}</span>
    <span>{{ action }}</span>
    <slot name="object" />
    <span class="ah-Time">{{ time }}</span>
  </div>
</template>

<script>
export default {
  name: 'ActivityHeader',
  props: {
    name: { type: String, required: true },
    action: { type: String, default: '' },
    time: { type: String, required: true }
  }
}
</script>

<style lang="scss" scoped>
.ah-Header {
  display: flex;
  gap: 4px;
  font-size: $fs-14;
  line-height: 20px;
  color: $dark-1;
  margin-bottom: 10px;
  padding-top: 2px;
  > *:not(.ah-Name) {
    flex-shrink: 0;
  }
}

.ah-Name {
  font-weight: fw('semi-bold');
  white-space: nowrap;
  overflow: hidden;
  color: $primary-color-next;
  text-overflow: ellipsis;
  flex: 0 1 auto;
}

.ah-Time {
  color: $dark-3;
  margin-left: 4px;
}
</style>
